(ns rothko.dom.event
  (:require [rothko.dom.input :as dom-input]))

(defn stop
  [event]
  (doto event .preventDefault .stopPropagation))

(defn dom-event
  [afn]
  (assert (ifn? afn))
  (fn [event]
    (afn (dom-input/event->value event))))
